import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { StripeProvider } from 'react-stripe-elements';
import { GoogleOAuthProvider } from '@react-oauth/google';
import moment from 'moment';
import 'rxjs';

import App from 'scenes/App';

import ScrollToTop from 'components/ScrollToTop';

import store from './redux/config';

import 'flatpickr/dist/themes/light.css';
import '@dev-go4ellis/go4-design-system/dist/tokens/tokens.css';
import '@dev-go4ellis/go4-design-system/dist/fonts/fonts.css';
// Component CSS is auto-imported via the package's JS sideEffects.
// The umbrella `dist/styles.css` is intentionally not imported — it references
// `./components/<Name>/<Name>.css` paths that don't exist in the published dist (packaging bug in v0.0.1).
import 'styles/styles.css';

import * as Sentry from '@sentry/browser';
import LogRocket from 'logrocket';
import { unregister } from './registerServiceWorker';

import RegistrationScene from 'scenes/RegistrationScene';
import LoadingSpinner from 'components/LoadingSpinner';
import FailedPaymentModals from 'components/FailedPaymentsModals/FailedPaymentModals';

moment.suppressDeprecationWarnings = true;
ReactGA.initialize('UA-120431567-1');

require('formdata-polyfill');

const stripeKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  serverName: 'go4ellis-frontend',
});
if (process.env.NODE_ENV !== 'development') {
  LogRocket.init(process.env.REACT_APP_LOG_ROCKET_ID, {
    network: {
      requestSanitizer: request => {
        if (request.body instanceof FormData) {
          request.body = JSON.stringify(Object.fromEntries(request.body));
        }

        return request;
      },
    },
  });
}

ReactDOM.render(
  <Provider store={store}>
    <GoogleOAuthProvider clientId={googleClientId}>
      <StripeProvider apiKey={stripeKey}>
        <BrowserRouter>
          <ScrollToTop>
            <LoadingSpinner />
            <FailedPaymentModals />
            <Suspense fallback={<LoadingSpinner />}>
              <Switch>
                <Route path="/sign-up" component={RegistrationScene} />
                <App />
              </Switch>
            </Suspense>
          </ScrollToTop>
        </BrowserRouter>
      </StripeProvider>
    </GoogleOAuthProvider>
  </Provider>,
  document.getElementById('root')
);

unregister();
